<script setup lang="ts">
import Pc from './components/Pc.vue'
import Mobile from './components/Mobile.vue'
import { useScreenStore } from '@/store/screen'

const screenStore = useScreenStore()
</script>

<template>
  <Pc v-if="screenStore.screen === 'pc'" />
  <Mobile v-else />
</template>
